import { initializeModals, displayToast, sendAppsignalError } from "../modules/utils";

class EMailNotificationAjaxForm {
  constructor(node) {
    this.element = node;
    this.eMailWrapper = this.element.querySelector(".js-e-mail-wrapper");
    this.contentWrapper = this.element.querySelector(".js-content-wrapper");

    this.intialize();
  }

  intialize() {
    this.addCheckboxListeners();

    this.eMailWrapper.addEventListener("ajax:post", (e) => {
      this.updateContent(e.detail.content);
    });
  }

  addCheckboxListeners() {
    this.checkboxButtons = this.element.querySelectorAll(".js-e-mail-checkbox");

    this.checkboxButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const url = new URL(button.href, window.location.origin);
        const input = button.querySelector("input");
        const { name, value } = input;

        url.searchParams.append(name, value);
        this.submitForm(url, input);
      });
    });
  }

  updateContent(content) {
    this.eMailWrapper.innerHTML = content;

    initializeModals(this.eMailWrapper);
    this.addCheckboxListeners();
  }

  submitForm(url, checkbox) {
    this.contentWrapper.classList.add("is-loading");

    fetch(url, {
      retries: 3,
      retryDelay: 1000,
      method: "POST",
      headers: {
        Accept: "application/json",
      },
    })
      .then((response) => {
        this.response = response;

        if (response.status === 200) {
          return response.json();
        }

        throw new Error("Something went wrong");
      })
      .then((data) => {
        this.updateContent(data.content);
      })
      .catch((e) => {
        console.error(e);
        checkbox.checked = !checkbox.checked;
        displayToast(this.element.dataset.errorMessage);
        sendAppsignalError(e, "EMailNotification", {
          response: this.response,
        });
      })
      .finally(() => {
        this.contentWrapper.classList.remove("is-loading");
      });
  }
}

const eMailNotification = document.querySelector('[data-js="e-mail-notification"]');

if (eMailNotification) {
  new EMailNotificationAjaxForm(eMailNotification);
}
